import { ApiTypes } from "types"

export const DEVICE_DEFAULT_QUANTITIES: Record<ApiTypes.Model.OrderProductType, number> = {
  thermostat: 20,
  thermostatV2: 20,
  cwa: 1,
  ths: 20,
  wls: 20,
}
